<template>
  <div class="checklist__description">
    <div
      v-if="!isEditing"
      class="checklist__description-content"
      @click="!isClient && openEditBox()"
    >
      <!-- show description -->
      <span v-if="checklistDescription" class="checklist__description-text">
        {{ checklistDescription }}
      </span>
      <!-- add description button -->
      <AppActionButton
        v-allowed:employee
        v-else-if="!checklistDescription && (isEditPage || !isTemplatePage)"
      >
        Añadir descripción
      </AppActionButton>
    </div>
    <!-- edit box -->
    <EditBox
      v-if="isEditing"
      :value="checklistDescription"
      @edition-done="prepareValues"
      @close-box="closeEditBox"
    />
  </div>
</template>

<script>
// Utilities
import ChecklistsMixin from '../mixins'
// Components
import AppActionButton from 'Ui/AppActionButton'

export default {
  name: 'ChecklistsChecklistDescription',

  components: {
    AppActionButton,
  },

  props: {
    checklist: {
      type: Object,
      required: true,
    },
  },

  mixins: [ChecklistsMixin],

  methods: {
    prepareValues(value) {
      const newData = {
        description: value,
      }

      // preparing requested values for API call
      const checklistInfo = this.getChecklistData({
        checklistId: this.checklist.id,
        newData: newData,
      })
      this.saveChanges(checklistInfo)
    },
  },
  computed: {
    isClient() {
      return this.userType === 'CLIENT'
    },

    checklistDescription() {
      return this.checklist.description
    },
  },

  watch: {
    changesSaved(saved) {
      saved && this.closeEditBox()
    },
  },
}
</script>

<style scoped>
.checklist__description {
  margin-top: 10px;
}

.checklist__description-text {
  font-size: 14px;
  color: var(--c-secondary);
}
</style>
